/*
 *  -----------------------------------------------------------------------
 *    <copyright file="form-control.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import FormControl from '@mui/material/FormControl';
import React from 'react';

export default function (props: any) {
    return <FormControl {...props} />;
}
